// Lib
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Util
import { manuallyReportError } from '../../../analytics/rollbarService';

// Actions
import { refreshPageAndClearLocalCache } from '../../../reducers/navigationActions';
import { intercomShowMessages } from '../../../analytics/analyticsActions';

// Components
import ModalActionsList from '../../modal/ModalActionsList';

// Constants
import LinkButton from '../../buttons/LinkButton';

type Props = {
    error: object;
};

/**
 * This component is intended to be used when a socket action fails after retrying many times.
 */
const SocketActionErrorContent: React.FC<Props> = ({ error }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        manuallyReportError({
            error: error,
            sensitive: false,
        });
    }, []);

    const actions = [
        {
            text: 'Try again',
            func: (event: Event) => {
                event.preventDefault();
                dispatch(refreshPageAndClearLocalCache());
            },
        },
    ];

    return (
        <>
            <h2>Save failure</h2>
            <div>
                <p>Something went wrong when saving.</p>
                <ModalActionsList actions={actions} />
            </div>
            <div className="section">
                <p>
                    Need help? <LinkButton onClick={() => dispatch(intercomShowMessages())}>Contact support</LinkButton>
                </p>
            </div>
        </>
    );
};

export default SocketActionErrorContent;
